var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tool-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasRes),expression:"hasRes"}],attrs:{"title":'测试用例'}},[_c('table-output')],1)}
var staticRenderFns = []

export { render, staticRenderFns }